<template>
  <nav data-component-name="Menu.Desktop">
    <ul>
      <li v-for="ITEM of MENU" :key="ITEM.i18nKey">
        <MenuDesktopItem
          :focused="hasColumns(ITEM) && isActiveItem(ITEM)"
          @click="toggleItem(ITEM)"
        >
          {{ $t(ITEM.i18nKey) }}
        </MenuDesktopItem>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
// components
import MenuDesktopItem from './MenuDesktopItem.vue';

// constants
import MENU from './constants';

// types
import type { MenuItemWithColumns, Menu } from './types';

const isActiveItem = (item: Menu[number]) => {
  if (hasColumns(item)) {
    return item.key === activeItem.value?.key;
  }

  return false;
};
const hasColumns = (item: Menu[number]): item is MenuItemWithColumns => {
  return 'columns' in item;
};

const activeItem = defineModel<null | MenuItemWithColumns>('activeItem', {
  default: null,
});

const toggleItem = (item: Menu[number]) => {
  let newItem: typeof activeItem.value = null;

  if (hasColumns(item) && !isActiveItem(item)) {
    newItem = item;
  }

  activeItem.value = newItem;
};
</script>

<style scoped lang="scss">
@use '_/mixins/flex';
@use '_/fn';

nav[data-component-name='Menu.Desktop'] {
  ul {
    @include flex.center-sb;

    color: fn.token('text-primary');
  }
}
</style>
